// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 1024px) {
    .main-content-part{
        padding: 30px 30px 0px 30px;
    }
    .main-content-part.topBox .innerInfo{
        padding: 20px 20px 0px 20px;
    }
    .componentBtn.green-btn{
        width: 100%;
    }
    .doctorDetailsCard{
        margin-bottom: 12px;
    }
    .top-orange-box{
        height: 100px;
    }
    .login-main .content-wrapper{
        grid-template-columns: 100%;
    }
    .login-main .form-part .content{
        align-items: center;
    }
    .login-main .form-part .content .header-part{
        width: 80%;
        max-width: 100%;
    }
    .doctorDetailsCard.startdata .rightPartData .filed{
        margin: 0 18px;
    }
    .exercise-tab-part .nav-tabs .nav-link{
        margin-bottom: 10px;
    }
    .serchPart .searchInput{
        width: 100%;
    }
    .chat-page .header-part .back-button, .chat-page .main-chat-part .chat-side-part{
        width: 45%;
    }
}
@media screen and (max-width: 991px) {
    .main-content-part.topBox .innerInfo .doctorDetailsCard{
        margin-bottom: 20px;
    }
    .common-link-card-part{
        max-width: 100%;
    }
    .form-data {
        max-width: 100%;
    }
    .header-main .search-part input{
        width: 100%;
    }
    .foot-sidebar{
        height: auto;
    }
    .main-content-part.foot-page .content-data{
        padding-left: 20px;
    }
    .chat-page .main-chat-part .chat-side-part, .chat-page .main-chat-part .messages-part .chatting, .chat-page .header-part .name-call{
        padding: 20px;
    }
}
@media screen and (max-width: 560px) {
    .topBar{
        flex-wrap: wrap;
        gap: 10px;
    }
    .layout-main .content-part .header-part{
        padding-left: 0  !important;
    }
    .header-main{
        padding: 12px;
    }
    .layout-main .sider{
        display: none;
    }
    .layout-main .content-part .content{
        padding-left: 0 !important;
    }
    .main-content-part{
        height: 80vh;
       max-height: 80vh !important;
       overflow: scroll !important;
    }
    .login-main .banner-part .banner-content .text-part p{
        display: none;
    }
    .login-main .banner-part .banner-content .text-part{
        width: 100%;
        max-width: 100%;
    }
    .login-main .form-part, .login-main .banner-part .banner-content{
        padding: 20px;
    }
    .main-content-part.excersiceList .exercise-tab-part {
        padding: 0 20px 0 20px;
    }
    .main-home-part{
        padding: 30px 0 100px 10px;
    }
    .chat-page .header-part .back-button, .chat-page .main-chat-part .chat-side-part{
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/responisve.css"],"names":[],"mappings":"AAAA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,cAAc;IAClB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,eAAe;QACf,SAAS;IACb;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,YAAY;OACb,2BAA2B;OAC3B,2BAA2B;IAC9B;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":["@media screen and (max-width: 1024px) {\r\n    .main-content-part{\r\n        padding: 30px 30px 0px 30px;\r\n    }\r\n    .main-content-part.topBox .innerInfo{\r\n        padding: 20px 20px 0px 20px;\r\n    }\r\n    .componentBtn.green-btn{\r\n        width: 100%;\r\n    }\r\n    .doctorDetailsCard{\r\n        margin-bottom: 12px;\r\n    }\r\n    .top-orange-box{\r\n        height: 100px;\r\n    }\r\n    .login-main .content-wrapper{\r\n        grid-template-columns: 100%;\r\n    }\r\n    .login-main .form-part .content{\r\n        align-items: center;\r\n    }\r\n    .login-main .form-part .content .header-part{\r\n        width: 80%;\r\n        max-width: 100%;\r\n    }\r\n    .doctorDetailsCard.startdata .rightPartData .filed{\r\n        margin: 0 18px;\r\n    }\r\n    .exercise-tab-part .nav-tabs .nav-link{\r\n        margin-bottom: 10px;\r\n    }\r\n    .serchPart .searchInput{\r\n        width: 100%;\r\n    }\r\n    .chat-page .header-part .back-button, .chat-page .main-chat-part .chat-side-part{\r\n        width: 45%;\r\n    }\r\n}\r\n@media screen and (max-width: 991px) {\r\n    .main-content-part.topBox .innerInfo .doctorDetailsCard{\r\n        margin-bottom: 20px;\r\n    }\r\n    .common-link-card-part{\r\n        max-width: 100%;\r\n    }\r\n    .form-data {\r\n        max-width: 100%;\r\n    }\r\n    .header-main .search-part input{\r\n        width: 100%;\r\n    }\r\n    .foot-sidebar{\r\n        height: auto;\r\n    }\r\n    .main-content-part.foot-page .content-data{\r\n        padding-left: 20px;\r\n    }\r\n    .chat-page .main-chat-part .chat-side-part, .chat-page .main-chat-part .messages-part .chatting, .chat-page .header-part .name-call{\r\n        padding: 20px;\r\n    }\r\n}\r\n@media screen and (max-width: 560px) {\r\n    .topBar{\r\n        flex-wrap: wrap;\r\n        gap: 10px;\r\n    }\r\n    .layout-main .content-part .header-part{\r\n        padding-left: 0  !important;\r\n    }\r\n    .header-main{\r\n        padding: 12px;\r\n    }\r\n    .layout-main .sider{\r\n        display: none;\r\n    }\r\n    .layout-main .content-part .content{\r\n        padding-left: 0 !important;\r\n    }\r\n    .main-content-part{\r\n        height: 80vh;\r\n       max-height: 80vh !important;\r\n       overflow: scroll !important;\r\n    }\r\n    .login-main .banner-part .banner-content .text-part p{\r\n        display: none;\r\n    }\r\n    .login-main .banner-part .banner-content .text-part{\r\n        width: 100%;\r\n        max-width: 100%;\r\n    }\r\n    .login-main .form-part, .login-main .banner-part .banner-content{\r\n        padding: 20px;\r\n    }\r\n    .main-content-part.excersiceList .exercise-tab-part {\r\n        padding: 0 20px 0 20px;\r\n    }\r\n    .main-home-part{\r\n        padding: 30px 0 100px 10px;\r\n    }\r\n    .chat-page .header-part .back-button, .chat-page .main-chat-part .chat-side-part{\r\n        width: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
